import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/constants";

const DEFAULTS = {
  address: "Jalan Gatot Subroto Baru No 17, Makassar, Sulawesi Selatan",
  whatsapp: "6285165458874",
  tagline: "Spesialis Sulawesi Selatan & Papua",
  heroTitle: "Kargo Sulsel Papua Terpercaya",
  heroSubtitle: "Spesialis rute Sulawesi Selatan dan Papua. Solusi pengiriman darat, laut, dan udara dalam satu pintu terintegrasi dengan tarif kompetitif untuk UMKM, korporasi, serta mitra ekspedisi.",
  services: null,
  faqs: null,
  promo: { enabled: false, text: "", ctaText: "Minta Penawaran" },
};

const SiteSettingsContext = createContext(DEFAULTS);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    axios.get(`${API}/settings`)
      .then((res) => { if (res.data && res.data.whatsapp) setSettings({ ...DEFAULTS, ...res.data }); })
      .catch(() => {});
  }, []);

  return <SiteSettingsContext.Provider value={settings}>{children}</SiteSettingsContext.Provider>;
}

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}

export function waLink(settings, message) {
  const text = encodeURIComponent(message || "Halo Nurrahma Logistics, saya ingin konsultasi tarif dan jadwal pengiriman...");
  return `https://wa.me/${(settings.whatsapp || DEFAULTS.whatsapp).replace(/[^0-9]/g, "")}?text=${text}`;
}
